import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import React from 'react';
import { getEnvVal } from '../../env';

export default class App extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    children: PropTypes.node,
  };

  constructor() {
    super();
    this.initRaven();
  }

  // Report browser errors from the production site only.
  initRaven = () => {
    const dsn = getEnvVal('SENTRY_DSN');
    const host = window.location.hostname;
    if (!dsn || host === 'localhost' || host === '127.0.0.1') {
      return;
    }
    Sentry.init({
      dsn,
      environment: 'PROD',
    });
  };

  render() {
    const { children } = this.props;
    return (
      <div>
        {React.Children.toArray(children)}
      </div>
    );
  }
}
